import template from './bookmarked_searches_list.template.html?raw';
import 'angular';

angular
  .module('directives.bookmarkedSearchesList', [])
  .run(['$templateCache', function($templateCache) {
    $templateCache.put(template, template);
  }])
  .directive('bookmarkedSearchesList', function() {
    return {
      restrict: 'E',
      templateUrl: template,
      scope: false
    };
  });
